export default {
  zh: {
    email: '邮箱',
    ':': '：',
    verificationCode: '验证码',
    getVerificationCode: '获取验证码',
    wait: '等待',
    bind: '绑定',
    bound: '已绑定',
    binding: '绑定中，请稍后',
    sendEmailSuccess: '绑定邮箱链接已发至您的邮箱，请查收！'
  },
  en: {
    email: 'Email',
    ':': ': ',
    verificationCode: 'Your Code',
    getVerificationCode: 'Send SMS',
    wait: 'Wait ',
    bind: 'Verify',
    bound: 'Verified',
    binding: 'Processing, please wait',
    sendEmailSuccess: 'The email verify link has been sent to your mailbox, please check!'
  }
}



// WEBPACK FOOTER //
// ./src/components/bindEmail/lang.js